<template>
  <div class="row justify-content-center text-center" v-if="numberData">
    <div class="col-md-6 col-lg-4 card mb-3 px-0">
      <div class="card-header text-light bg4">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Carrier Type</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="NumberRouting.AllNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-megaphone-fill icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">{{ numberData.allNumbersCarrierType }}</p>
          </div>

          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Carrier Type</template>
              <template v-slot:body>
                This shows the carrier type set for the selected number in
                Number Routing
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card mb-3 px-0">
      <div class="card-header text-light bg5">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Provider Type</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="CallRouting.PurchasedNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-phone-landscape-fill icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">
              {{ numberData.purchasedNumbersProviderType }}
            </p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Provider Type</template>
              <template v-slot:body>
                This shows the number provider type set for the selected number
                in Call Routing
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card  mb-3 px-0">
      <div class="card-header text-light bg6">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Reserved Date</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="NumberRouting.AllNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-1">
            <i class="bi bi-calendar-week-fill icon-size"></i>
          </div>
          <div class="col-sm-9 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">
              {{ numberData.allNumbersReservedDate }}
            </p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Reserved Date</template>
              <template v-slot:body>
                This is the date that the selected number was added to the
                account
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card  mb-3 px-0">
      <div class="card-header text-light bg7">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Quarantine Date</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="NumberRouting.AllNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-calendar-event-fill icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">
              {{ numberData.allNumbersQuarantineDate }}
            </p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Quarantine Date</template>
              <template v-slot:body>
                If the selected number is in quarantine then this date is shown
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card mb-3 px-0">
      <div class="card-header text-light bg8">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Number Type</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="CallRouting.PurchasedNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-headset icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">{{ numberData.purchasedNumbersType }}</p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Purchased Number Type</template>
              <template v-slot:body>
                This shows the type of number that has been selected: Business
                number, Divert number or Personal DDI
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card  mb-3 px-0">
      <div class="card-header text-light bg9">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Route Type</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="CallRouting.PurchasedNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-reception-4 icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <p class="my-auto">{{ routeType }}</p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Route Type</template>
              <template v-slot:body>
                If the account is a Clever Number or a PPS account this will
                show as either 'Recipient' (which means it is set to go to a
                specific recipient) or Digital receptionist
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-4 card mb-3 px-0">
      <div class="card-header text-light bg10">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Product Type</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="CallRouting.PurchasedNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-phone-vibrate-fill icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">{{ productType }}</p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Product Type</template>
              <template v-slot:body>
                This shows the product the selected number is attached to, TAS,
                PPS, Clever Numbers etc...
              </template>
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 card mb-3 px-0">
      <div class="card-header text-light bg11">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <h5 class="card-title mb-0">Outbound Status</h5>
          </div>
          <div class="col-sm-2">
            <i
              class="bi bi-hdd-stack-fill"
              title="CallRouting.PurchasedNumbers"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2">
            <i class="bi bi-telephone-outbound-fill icon-size"></i>
          </div>
          <div class="col-sm-8 my-auto">
            <div v-if="loading">
              <Spinners />
            </div>
            <p v-else class="my-auto">
              {{ numberData.purchasedNumbersOutboundStatus }}
            </p>
          </div>
          <div class="col-sm-1 my-auto">
            <InfoCard>
              <template v-slot:header>Outbound Status</template>
              <template v-slot:body>
                This shows if the selected number is being allowed as a CLI to
                show when making outbound calls via the App.</template
              >
            </InfoCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SearchByNumber } from "@/services/number.js";
import InfoCard from "@/components/InfoCard.vue";
import Spinners from "@/components/Spinners.vue";
let numberInfo = null;

export default {
  async setup(props) {
    numberInfo = await SearchByNumber(props.number);
  },
  mounted() {
    this.numberData = numberInfo;
    this.productType = numberInfo.purchasedNumbersProductType;
    this.carrierType = numberInfo.allNumbersCarrierType;
    this.$emit("carrierTypeUpdated", numberInfo.allNumbersCarrierType);
  },
  data() {
    return {
      numberData: null,
      productType: null,
      loading: false,
      carrierType: null,
    };
  },
  methods: {
    async GetNumberData(number) {
      this.loading = true;
      this.numberData = await SearchByNumber(number);
      this.loading = false;
      this.productType = this.numberData.purchasedNumbersProductType;
      this.carrierType = this.numberData.allNumbersCarrierType;
      this.$emit("carrierTypeUpdated", this.numberData.allNumbersCarrierType);
    },
  },
  watch: {
    number: function(val) {
      this.GetNumberData(val);
    },
  },
  computed: {
    routeType() {
      return this.productType === "Pocket Phone" ||
        this.productType === "Clever Numbers"
        ? this.numberData.purchasedNumbersRouteType
        : "N/A";
    },
  },
  props: {
    number: {
      type: String,
      required: true,
    },
  },
  components: {
    InfoCard,
    Spinners,
  },
};
</script>

<style>
.icon-size {
  font-size: 2rem;
}
</style>
